<div id="gerador-ordem" class="page-layout carded fullwidth">

    <!-- TOP BACKGROUND -->
    <div class="top-bg accent"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">

        <!-- HEADER -->
        <div class="header accent"
             fxLayout="column" fxLayoutAlign="center center"
             fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="space-between center">
             

            <!-- TÍTULO E BOTÕES ALINHADOS -->
            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="nogrow">
                <!-- TÍTULO -->
                <div class="logo mb-24 mb-md-0"
                     fxLayout="row" fxLayoutAlign="start center">
                    <mat-icon class="logo-icon s-32 mr-16">
                        attach_money
                    </mat-icon>
                    <span class="logo-text h1">
                        Gerador de Ordens de Renda Variável
                    </span>
                </div>
                <!-- / TÍTULO -->

                <!-- BOTÕES DE AÇÃO -->
                <div fxLayout="row" fxLayoutAlign="start center" style="margin-left: 16px; gap: 8px;">
                    <!-- Botão Novo -->
                    <button mat-mini-fab
                            color="accent"
                            matTooltip="Novo Gerador de Ordens"
                            (click)="openCadastro()">
                        <mat-icon>add</mat-icon>
                    </button>
                </div>
                <!-- / BOTÕES DE AÇÃO -->
            </div>
            <!-- / TÍTULO E BOTÕES ALINHADOS -->

        </div>
        <!-- / HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card">               
            <div class="content p-24">

                <div fxLayout="column" fxLayoutAlign="center">
                    <div 
                        class="filters" 
                        fxLayout="column" 
                        fxLayoutAlign="center center"
                        fxLayout.gt-xs="row" 
                        fxLayoutAlign.gt-xs="space-between center"
                    >   
                        <div class="course-search">
                            <mat-form-field appearance="outline" floatLabel="always" style="margin-right: 10px;" >
                                <mat-label>Data da Operação Início</mat-label>
                                <input 
                                    matInput 
                                    [matDatepicker]="picker" 
                                    (dateChange) = "getAll()"
                                    [formControl]="data_operacao_inicio" 
                                    name="data_operacao_inicio" 
                                    placeholder="Data da Operação"
                                >
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                            </mat-form-field>
                    
                            <mat-form-field appearance="outline" floatLabel="always">
                                <mat-label>Data da Operação Fim</mat-label>
                                <input 
                                    matInput 
                                    [matDatepicker]="pickerFim" 
                                    [formControl]="data_operacao_fim" 
                                    (dateChange) = "getAll()"
                                    name="data_operacao_fim" 
                                    placeholder="Data da Operação"
                                >
                                <mat-datepicker-toggle matSuffix [for]="pickerFim"></mat-datepicker-toggle>
                                <mat-datepicker #pickerFim></mat-datepicker>
                            </mat-form-field> 
                        </div>                                      
                        
                        <mat-form-field class="category-selector" appearance="outline">
                            <mat-label>Estratégia</mat-label>                        
                            <mat-select
                                [formControl]="estrategia_id"
                                name="status_id"
                                (selectionChange)="getAll()"
                            >
                                    <mat-option value="">Todos</mat-option>
                                    <mat-option *ngFor="let estrategia of listEstrategia" [value]="estrategia.id">{{estrategia.nome}}</mat-option>
                                </mat-select>
                                <mat-spinner diameter="20" *ngIf="loadingSpinnerEstrategia"></mat-spinner>
                        </mat-form-field>
                    </div>
    
                    <div class="courses" fxLayout="row wrap" fxLayoutAlign="center" [@animateStagger]="{value:'50'}">
    
                        <div 
                            *ngFor="let gerador of filteredGerador" 
                            fxFlex="100" 
                            fxFlex.gt-xs="50"
                            class="course" 
                            fxFlex.gt-sm="33" 
                            [ngClass]="gerador.estrategia" 
                            [@animate]="{value:'*',params:{y:'100%'}}"
                        >
        
                            <div class="course-content" fxLayout="column" fxFlex="1 1 auto">
        
                                <div 
                                    class="header" 
                                    fxLayout="row" 
                                    fxLayoutAlign="center center"
                                    [ngClass]="gerador.estrategia.cor_hexadecimal"
                                >
        
                                    <div class="category" fxFlex>
                                        {{gerador.estrategia.nome}}
                                    </div>
        
                                    <div class="length" fxLayout="row" fxLayoutAlign="center center">
                                        <mat-icon class="length-icon s-20">people</mat-icon>
                                        <div class="min">{{gerador.qtd_boletas}}</div>
                                    </div>
        
                                </div>
        
                                <div class="content" fxLayout="column" fxLayoutAlign="center center" fxFlex="1 1 auto">
                                    <div class="h1">{{gerador.rotulo}}</div>
                                    <div class="updated">Data {{gerador.data_operacao | date:'dd/MM/yyyy'}}</div>
                                    <div class="updated">{{gerador.user.name }}</div>
                                    <div class="updated">R$ {{gerador.vlr_financeiro | number : '1.2-2' }}</div>
                                </div>
        
                                <div 
                                    class="footer" 
                                    fxLayout="row" 
                                    fxLayoutAlign="center center"
                                    *ngIf="!gerador.finalizada"
                                >
                                    <button 
                                        mat-button                                         
                                        color="accent"
                                        [routerLink]="'/renda-variavel/gerador-ordens/' + gerador.id"                                        
                                    >
                                        ENTRAR
                                    </button>

                                    <button 
                                        mat-button                                         
                                        (click)="finalizaGerador(gerador.id)"
                                        style="color: #43a047!important"
                                    >
                                        FINALIZAR
                                    </button>

                                    <button 
                                        mat-button                                         
                                        color="warn"
                                        (click)="delete(gerador.id)"
                                    >
                                        EXCLUIR
                                    </button>
                                </div>
        
                            </div>
        
                        </div>
        
                        <div class="no-courses" *ngIf="filteredGerador.length === 0">
                            Nenhum Registro Encontrado!
                        </div>
        
                    </div>
    
                </div>
            </div>
        </div>
    </div>
</div>